import { render, staticRenderFns } from "./CartoesCreditoCadastrar.vue?vue&type=template&id=5d508740"
import script from "./CartoesCreditoCadastrar.vue?vue&type=script&lang=js"
export * from "./CartoesCreditoCadastrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports